/* global axios */
import ApiClient from './ApiClient';

class BridgeToolsAPI extends ApiClient {
  constructor() {
    super('bridge_tools', { accountScoped: true });
  }

  shareLink(conversationId) {
    return axios.get(`${this.url}/share_link`, {
      params: { conversation_id: conversationId },
    });
  }

  subscriptionLookup(email) {
    return axios.get(`${this.url}/subscription_lookup`, {
      params: { email },
    });
  }
}

export default new BridgeToolsAPI();
